import { toValidDate } from "@spiriidk/utils";
import type { EnvironmentBuildResponse } from "connect-api/enums/schemas/environment";

interface EnvironmentInfo {
  env: string;
  serverBuild: string;
  serverBuildDate: Date | null;
  clientBuild: string;
  clientBuildDate: Date | null;
}

function parseDate(value: unknown): Date | null {
  if (typeof value !== "string") return null;

  return toValidDate(value) ?? null;
}

function toEnvironmentInfo({
  env,
  build,
  buildTime,
}: EnvironmentBuildResponse): EnvironmentInfo {
  const appVersion: unknown = import.meta.env.VITE_APP_VERSION;
  const buildDate: unknown = import.meta.env.VITE_BUILD_DATE;

  return {
    env,
    serverBuild: build,
    serverBuildDate: parseDate(buildTime),
    clientBuild: typeof appVersion === "string" ? appVersion : "Unknown",
    clientBuildDate: parseDate(buildDate),
  };
}

export { toEnvironmentInfo };
export type { EnvironmentInfo };
